import React, { ReactNode, CSSProperties, useRef } from "react";
import styled from "@emotion/styled";
import { useGlobalHeaderConfig } from "src/hooks/useGlobalHeaderConfig";

const Block = styled.div`
  outline: none;
`;

type Props = {
  children: ReactNode;

  // Hold off on focusing while this property is true (e.g. if there's a modal
  // visible over the component, the block should only come into focus once the
  // modal has been dismissed)
  deferFocus?: boolean;
  preventScroll?: boolean;

  className?: string;
  style?: CSSProperties;
};

export function PrimaryFocusBlock({
  children,
  deferFocus = false,
  preventScroll = false,
  ...otherProps
}: Props) {
  const focusTriggered = useRef(false);
  const globalHeader = useGlobalHeaderConfig();
  // Preventing scroll when there is a sticky global header
  // because the content would move below the header
  const shouldPreventScroll =
    preventScroll || (globalHeader.enabled && globalHeader.sticky);

  return (
    <Block
      ref={(node) => {
        if (node && !focusTriggered.current && !deferFocus) {
          node.focus({ preventScroll: shouldPreventScroll });
          focusTriggered.current = true;
        }
      }}
      tabIndex={-1}
      {...otherProps}
    >
      {children}
    </Block>
  );
}
